import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';
import NodeAnnualReportCard from '../../../../../implementations/Node/AnnualReport/Card';
import type { SearchAllContentAnnualReportHit } from '../../../../SearchAllContent/types';

const MetaSearchAnnualReportHit: React.FC<{ hit: SearchAllContentAnnualReportHit }> = ({ hit }) => (
  <NodeAnnualReportCard
    title={hit.page_title[0]}
    link={hit.link_url[0]}
    image={(
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['16_9', '16_9', '16_9', '16_9', '16_9'],
          ['xs', 'xs', 'sm', 'sm', 'sm'],
        )}
        alt=""
        lazyload={false}
      />
    )}
  />
);

export default MetaSearchAnnualReportHit;
